import "./layout.css";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useContext, useEffect } from "react";
// import { WorkerContext } from "../../context/worker/worker.context";
import { UserContext } from "../../context/user.context";
import { AuthContext } from "../../context/auth.context";
import { DisplayContext } from "../../context/display.context";

export default function Layout() {

    const { pathname } = useLocation();
    const navigate = useNavigate();
    // const { worker } = useContext(WorkerContext);
    const [user] = useContext(UserContext);
    const [, setAuth] = useContext(AuthContext);
    // const [, setTokens] = useContext(AuthContext);
    const devicdeWidth = useContext(DisplayContext);

    useEffect(()=>{
        window.scrollTo(0, 0);
    }, [pathname]);

    function logout() {
        // dispatch(user, 'clear');
        setAuth(undefined);
        navigate('/');
    }

    return (
        <>
            {/* <header className="d-flex justify-content-between">
                <h1><Link to="/">
                    <img src="images/logo-white.png" 
                        height={devicdeWidth > 768 ? 64 : 32}
                    />
                </Link></h1>
                <nav>
                    <ul>
                        <li><Link to="/" className={pathname === '/' ? 'active' : ''}>Home</Link></li>
                        <li><Link to="/explore" className={pathname === '/explore' ? 'active' : ''}>Explore</Link></li>
                        {!user && <>
                            <li><Link to="/auth/signin" className={pathname === '/auth/signin' ? 'active' : ''}>Sign In</Link></li>
                            <li><Link to="/auth/signup" className={pathname === '/auth/signup' ? 'active' : ''}>Sign Up</Link></li>
                        </>}
                    </ul>
                </nav>
                {user && <div>
                    <Link to={'/account'} className="d-flex align-items-center btn text-light">
                        <img alt="" src="" className="border rounded-circle me-3" width={30} height={30} />
                        <span>{user.username}</span>
                    </Link>
                </div>}
            </header> */}

            <nav className="navbar sticky-top navbar-expand-lg">
                <div className="container-fluid">
                    <Link to={"/"} className="navbar-brand">
                        <img src="/images/logo-white.png" height={devicdeWidth > 768 ? 64 : 32} />
                    </Link>
                    <button className="navbar-toggler text-light" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon bg-light"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0 d-flex justify-content-center w-100">
                            <li className={`nav-item`}>
                                <Link className={`nav-link ${`nav-item ${pathname === '/' ? 'active' : ''}`}`} aria-current="page" to="/">Home</Link>
                            </li>
                            <li className={`nav-item`}>
                                <Link className={`nav-link  ${pathname === '/explore' ? 'active' : ''}`} to="/explore">Explore</Link>
                            </li>
                            {!user && <>
                                <li className={`nav-item`}>
                                    <Link to="/auth/signin" className={`nav-link  ${pathname === '/auth/signin' ? 'active' : ''}`}>Sign In</Link></li>
                                <li className={`nav-item`}>
                                    <Link to="/auth/signup" className={`nav-link ${pathname === '/auth/signup' ? 'active' : ''}`}>Sign Up</Link></li>
                            </>}
                        </ul>
                        {user && <div className="dropdown">
                            <Link className="dropdown-toggle" to="#" role="button" data-bs-toggle="dropdown" aria-expanded="true">
                                <img alt="" src="" className="border rounded-circle me-3" width={30} height={30} />
                                <span>{user.username}</span>
                            </Link>
                            <ul className="dropdown-menu ms-auto">
                                <li><Link className="dropdown-item text-dark" to="/account">My Profile</Link></li>
                                <li><Link className="dropdown-item text-dark" to="/account/uploads">My Uploads</Link></li>
                                <li><Link className="dropdown-item text-dark" to="/account/wins">My Wins</Link></li>
                                <li><Link className="dropdown-item text-dark" to="/account/settings">Settings</Link></li>
                                <li><hr className="dropdown-divider" /></li>
                                <li><Link className="dropdown-item text-dark" to="#" onClick={logout}>Logout</Link></li>
                            </ul>
                        </div>}
                    </div>
                </div>
            </nav>

            <main>
                <Outlet />
            </main>

            <footer className="">

                <div className={`${devicdeWidth > 480 ? 'p-5' : 'p-3'} d-md-flex align-items-center`}>

                    <div className={devicdeWidth > 480 ? `w-50` : 'mb-3 text-justified'}>
                        <h3>A snippet about Play2o</h3>
                        <p>Lorem Ipsum is simply dummy text of the printing and
                            typesetting industry. <br />Lorem Ipsum has been the industry's
                            standard dummy text ever since the 1500s, when an unknown
                            printer took a galley of type and scrambled it to make a</p>
                        <img src="/images/google-playstore.png" width={200} />
                    </div>

                    <div className="d-flex ms-auto justify-content-between">
                        <div className="me-4 d-flex flex-column link-group">
                            <Link to={'/contactus'} className="d-block p-2 text-white">Contact Us</Link>
                            <Link to={'/auth/signin'} className="d-block p-2 text-white">Sign In</Link>
                            <Link to={'/auth/signup'} className="d-block p-2 text-white">Sign Up</Link>
                            <Link to={'/termsofuse'} className="d-block p-2 text-white">Terms of Use</Link>
                            <Link to={'/privacypolicy'} className="d-block p-2 text-white">Privacy Policy</Link>
                        </div>
                       
                        {/* <div className=" link-group d-flex flex-column">
                            <Link to={'/contactus'} className="d-block p-2 text-white">Contact Us</Link>
                            <Link className="d-block p-2 text-white">Sign In</Link>
                            <Link className="d-block p-2 text-white">Sign Up</Link>
                            <Link to={'/termsofuse'} className="d-block p-2 text-white">Terms of Use</Link>
                            <Link to={'/privacypolicy'} className="d-block p-2 text-white">Privacy Policy</Link>
                        </div> */}
                    </div>

                </div>

                <div className="text-center bg-white text-black p-3 mt-auto d-flex justify-content-between">
                    <div>
                        <strong>Patent pending</strong>
                    </div>
                    <div>Play2o &copy; {(new Date()).getFullYear()}</div>
                    <div>All Rights Reserved</div>
                </div>

            </footer>
        </>
    );
}
